import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as S from './styled';


export default function App() {
  let [ usuario, setUsuario ] = useState('') 
  let navigate = useNavigate(); 
  const [erro, setErro] = useState(false);
  

  function handlePesquisa () {
    axios.get(`https://api.github.com/users/${usuario}/repos`)
      .then((response) => {
        const repositories = response.data;
        const repositoriesName = [];
        repositories.map((repository) => {
            repositoriesName.push(repository.name)
        });
        localStorage.setItem('repositoriesName',JSON.stringify(repositoriesName));
        setErro(false)
        navigate('/repositories');        
      })
      .catch(err => {
        setErro(true);
      })
  } 

  const handleKeyDown = (event) => {
    if(event.keyCode === 13) {
      handlePesquisa();
    }
  }

  return (
    <S.Container>
      <S.Title>Usuário no GitHub: { usuario }</S.Title>
      <S.Input className='usuarioInput' value={ usuario } onChange={event => setUsuario(event.target.value)} onKeyDown={ handleKeyDown } />
      <S.Button type='button' onClick={ handlePesquisa } >Pesquisar!</S.Button>
      { erro ? <S.ErrorMsg>Sorry, não encontramos nenhum respositório.</S.ErrorMsg> : ' ' }
    </S.Container>
  );
}
